import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { scrollToAnchor } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import './LegalNoticePage.scss';

class LegalNoticePage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;
        return (
            <main role="main" className="conteneur conteneur-mobile" id="p-mentionslegales">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.LEGAL_NOTICE_PATH}`}
                />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: i18n.BREADCRUMB,
                            route: PATH.LEGAL_NOTICE_PATH
                        }
                    ]}
                />
                <h1>{i18n.TITLE}</h1>

                <h3>{i18n.TITLE1}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_1)}</p>
                <p>{i18n.TEXT1_2}</p>
                <p>{i18n.TEXT1_3}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{i18n.TEXT2_1}</p>
                <p>{i18n.TEXT2_2}</p>

                <h3>{i18n.TITLE3}</h3>
                <p>{i18n.TEXT3_1}</p>

                <h3>{i18n.TITLE4}</h3>
                <p>{i18n.TEXT4_1}</p>
                <p>{i18n.TEXT4_2}</p>

                <h3>{i18n.TITLE5}</h3>
                <p>{i18n.TEXT5_1}</p>
                <p>{i18n.TEXT5_2}</p>

                <h3>{i18n.TITLE6}</h3>
                <p>{i18n.TEXT6_1}</p>
                <p>{i18n.TEXT6_2}</p>
                <p>{i18n.TEXT6_3}</p>
                <p>{i18n.TEXT6_4}</p>

                <h3>{i18n.TITLE7}</h3>
                <p>{i18n.TEXT7_1}</p>
                <p>{i18n.TEXT7_2}</p>
                <p>{i18n.TEXT7_3}</p>

                <h3>{i18n.TITLE8}</h3>
                <p>{i18n.TEXT8_1}</p>
                <p>{i18n.TEXT8_2}</p>
                <p>{i18n.TEXT8_3}</p>
                <p>{i18n.TEXT8_4}</p>

                <h3>{i18n.TITLE9}</h3>
                <p>{i18n.TEXT9_1}</p>
                <p>{i18n.TEXT9_2}</p>
                <p>{i18n.TEXT9_3}</p>

                <h3>{i18n.TITLE10}</h3>
                <p>{i18n.TEXT10_1}</p>
                <p>{i18n.TEXT10_2}</p>

                <h3>{i18n.TITLE11}</h3>
                <p>{i18n.TEXT11_1}</p>
            </main>
        );
    }
}

LegalNoticePage.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.LEGAL_NOTICE
    };
}

export default withTemplate(connect(mapStateToProps)(LegalNoticePage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/legalnotice/LegalNoticePage.js